import { render, staticRenderFns } from "./WomanTravelerPlane.vue?vue&type=template&id=b9082d7c&scoped=true&"
import script from "./WomanTravelerPlane.vue?vue&type=script&lang=ts&"
export * from "./WomanTravelerPlane.vue?vue&type=script&lang=ts&"
import style0 from "./WomanTravelerPlane.vue?vue&type=style&index=0&id=b9082d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9082d7c",
  null
  
)

export default component.exports